import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const SubscriptionCard = ({ image, title, price, isSelected, onSelect }) => {
  return (
    <Card
      onClick={onSelect}
      sx={{
        borderRadius: "30px",
        background: isSelected
          ? "#ffffff"
          : "linear-gradient(90deg, #669cf399 1%, #9ad3de99 15.5%, #ebdadc99 69.5%, #9faff399 100%)",
        mt: 2,
        boxShadow: "none",
        cursor: "pointer",
        transition: "all 0.3s ease-in-out",
      }}
    >
      <CardContent
        sx={{ display: "flex", gap: 2, p: 2, "&:last-child": { pb: 2 } }}
      >
        <Box
          component="img"
          src={image}
          alt={`${title} subscription`}
          sx={{
            width: 56,
            aspectRatio: "1",
            objectFit: "contain",
            objectPosition: "center",
            alignSelf: "center",
          }}
        />
        <Box sx={{ flex: 1, minWidth: 240 }}>
          {/* Title */}
          <Typography
            variant="h6"
            component="h3"
            sx={{
              fontFamily: isSelected ? "Inter700" : "Inter600",
              fontWeight: isSelected ? 700 : 600,
              fontSize: "17px",
              lineHeight: isSelected ? "135%" : "100%",
              letterSpacing: "0%",
              color: isSelected ? "#000000" : "#ffffff",
            }}
          >
            {title}
          </Typography>

          {/* Price + Year */}
          <Typography
            sx={{
              mt: 0.5,
              fontFamily: "Inter400",
              fontWeight: 400,
              fontSize: "17px",
              lineHeight: "135%",
              letterSpacing: "0%",
              color: isSelected ? "#000000" : "#ffffff",
            }}
          >
            <Box
              component="span"
              sx={{
                fontFamily: isSelected ? "Inter700" : "Inter600",
                fontWeight: 700,
                color: isSelected ? "#000000" : "#ffffff",
              }}
            >
              ₹{price}
            </Box>{" "}
            / Year
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default SubscriptionCard;
